import React from "react";
import { NavLink } from "react-router-dom";
import { MdDashboard, MdSettings, MdList, MdVideocam } from "react-icons/md";

const NAV_ITEMS = [
  { to: "/dashboard", icon: MdDashboard, label: "Dashboard" },
  { to: "/config", icon: MdSettings, label: "Algorithm Config" },
  { to: "/tasks", icon: MdList, label: "Task List" },
  { to: "/event", icon: MdList, label: "Event List" },
];

export const Sidebar: React.FC = () => {
  return (
    <aside className="w-60 min-h-screen bg-gray-900 text-white flex flex-col">
      {/* Logo */}
      <div className="flex items-center gap-2.5 px-5 py-5 border-b border-gray-800">
        <div className="w-8 h-8 bg-indigo-500 rounded-lg flex items-center justify-center">
          <MdVideocam size={18} />
        </div>
        <div>
          <p className="text-sm font-bold leading-none">POC Koja</p>
          <p className="text-xs text-gray-400 mt-0.5">Dashboard</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        <p className="text-[10px] text-gray-500 uppercase tracking-widest px-2 mb-2">
          Main Menu
        </p>
        {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive
                  ? "bg-indigo-600 text-white font-medium"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white"
              }`
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Version */}
      <div className="px-5 py-4 border-t border-gray-800">
        <p className="text-xs text-gray-600">API v1.0</p>
      </div>
    </aside>
  );
};
